import React from 'react';
import { useDispatch } from 'react-redux';
import { Card, Icon, IconButton } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { imgBaseUrl } from 'configs';
import logo from 'components/Logo/logo-dermpro.svg';
import BackdropCircular from 'components/Backdrop/BackdropCircular';
import {removeTaskFromQueueApi} from 'api';


const displayStatus = {
  'WAITING': 'In queue',
  'RUNNING': 'Processing',
  'FAILED': 'Error'
};

const StoreProductsQueue = ({ queueTasks }) => {
  const dispatch = useDispatch();
  const columns = [
    {
      name: 'name', // field name in the row object
      label: 'Item', // column title that will be shown in table
      options: {
        sort: false,
        filter: false,
        setCellHeaderProps: () => ({style: {fontSize: '14px'}}),
        customBodyRenderLite: (dataIndex) => {
          const task = queueTasks[dataIndex];
          const mediaStoreUrl = `${task.store?.apiUrl}/media/catalog/product` || imgBaseUrl;
          const productImagePath = task?.body?.custom_attributes?.find((attr) => attr?.attribute_code === 'image')?.value;
          const imageUrl = productImagePath ? `${mediaStoreUrl}${productImagePath}` : logo;

          return (
            <div className="flex items-center">
              <img
                src={imageUrl}
                alt={task.name}
                style={{maxHeight: '60px', width: '60px', objectFit: 'contain'}}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = logo;
                }}
              />
              <div className="ml-3">
                <p className="my-0 text-15" >{task.name}</p>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: 'status',
      label: 'status',
      options: {
        sort: false,
        filter: false,
        setCellHeaderProps: () => ({style: {width: '30%', textTransform: 'Capitalize', fontSize: '14px', textAlign: 'start'}}),
        customBodyRenderLite: (dataIndex) => {
          const task = queueTasks[dataIndex];

          return (
            <>
              <div className="flex items-center justify-start">
                {displayStatus[task.status]}
              </div>
              {task.status === 'FAILED' &&
              <div className="flex items-center justify-start">
                {task.error.message}
              </div>
              }
            </>
          );
        },
      }
    },
    {
      name: 'action',
      label: 'Actions',
      options: {
        sort: false,
        setCellHeaderProps: () => ({className: 'pr-8 w-100'}),
        customBodyRenderLite: (dataIndex) => {
          const task = queueTasks[dataIndex];

          return (
            <div>
              {task.status === 'FAILED' &&
              <IconButton
                title="Delete from queue"
                onClick={() => removeTaskFromQueueApi({ dispatch, task })}
              >
                <Icon>delete</Icon>
              </IconButton>}
            </div>
          );
        }
      }
    },
  ];

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <Card>
        <MUIDataTable
          data={queueTasks}
          columns={columns}
          options={{
            responsive: 'standard',
            selectableRows: 'none', // set checkbox for each row
            search: false, // set search option
            filter: false, // set data filter option
            download: false, // set download option
            print: false, // set print option
            pagination: false, //set pagination option
            viewColumns: false, // set column option
            elevation: 0,
          }}
        />
        <BackdropCircular loading={false} />
      </Card>
    </div>
  );
};

export default StoreProductsQueue;
